<div class="tile-progress bg-white text-left col-lg-12">
    <label>Select Account</label>
    <ng-select style="width:35%" [items]="accounts" (change)="getScreeningCentersAndScreningEvents()" name="accounts"
        bindLabel="accountName" [(ngModel)]="accountId" [clearable]="true" [searchable]="true" bindValue="accountId"
        placeholder="Select account" [disabled]="!listing">
    </ng-select>
</div>

<div *ngIf="isAccountSelected">

    <div class="card-header">
        <span [ngSwitch]="listing">
            <span *ngSwitchCase="false">Add/Update Event</span>
            <span *ngSwitchCase="true">Existing Events</span>
        </span>
    </div>

    <div style="text-align: end; margin-bottom:20px">
        <button type="button" (click)="toggleView()" class="btn btn-info btn-raised">
            <span *ngIf="listing" tooltip="Click here to add new admin user">
                <i class="fa fa-plus-circle" style="margin-top:6px;color:#fff;"></i> New Screening Event</span>
            <span *ngIf="!listing">
                <i class="fa fa-arrow-left" style="margin-top:6px;color:#fff;"></i> Back</span>
        </button>
    </div>

    <div>
        <div class="content-body padding-top-20 padding-bottom-20">
            <div class="row">
                <div *ngIf="listing; then tableTemplate; else screeningEventTemplate;">
                </div>
                <ng-template #tableTemplate>
                    <p-table [value]="eventsList" [paginator]="eventsList!=null && eventsList.length>10" [rows]="10"
                        #dt>
                        <ng-template pTemplate="header">
                            <tr style="height:80px;">
                                <th style="width:50px;text-align: center;">#
                                </th>
                                <th style="width: 250px;">Event Name
                                </th>
                                <th style="width: 140px;">Start Date
                                </th>
                                <th style="width: 140px;">End Date
                                </th>
                                <th style="width: 350px;">Invite Link
                                </th>
                                <th style="width: 140px;">Status
                                </th>
                            </tr>
                            <tr *ngIf="eventsList==null || eventsList.length==0"
                                style="border-left: 1px solid #f4f4f4;border-right: 1px solid #f4f4f4;border-bottom: 1px solid #f4f4f4;">
                                <td colspan="6">
                                    <div style="padding: 5px;text-align: center;">
                                        No events found
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="eventsList!=null && eventsList.length>0"
                                style="font-family:Arial, FontAwesome;text-align: center;">
                                <td class="primeng-table-search">
                                    <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                                (input)="dt.filter($event.target.value, 'firstName', 'contains')"> -->
                                </td>
                                <td class="primeng-table-search">

                                    <!-- <input class="primeng-table-search-field search-bar-true"
                                        placeholder="&#xf002;  Event Name " pInputText type="text"
                                        (input)="dt.filter($event.target.value, 'eventName', 'contains')"> -->
                                </td>
                                <td class="primeng-table-search">
                                    <!-- <input class="primeng-table-search-field search-bar-true"
                                        placeholder="&#xf002;  E-mail" pInputText type="text"
                                        (input)="dt.filter($event.target.value, 'email', 'contains')"> -->
                                </td>
                                <td class="primeng-table-search">
                                    <!-- <input class="primeng-table-search-field search-bar-true"
                                        placeholder="&#xf002;  Mobile number" pInputText type="text"
                                        (input)="dt.filter($event.target.value, 'phoneNo', 'contains')"> -->
                                </td>
                                <td class="primeng-table-search">
                                    <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                                (input)="dt.filter($event.target.value, 'firstName', 'contains')"> -->
                                </td>
                                <td class="primeng-table-search">
                                    <!-- <input class="primeng-table-search-field" disabled pInputText type="search"
                                (input)="dt.filter($event.target.value, 'firstName', 'contains')"> -->
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-eventsList let-i="rowIndex">
                            <tr class="table-striped" style="cursor: pointer;">
                                <td (click)="editEvent(eventsList)"
                                    style="text-align: center;padding-bottom: 25px;padding-top:25px;">{{ i + 1}}</td>
                                <td (click)="editEvent(eventsList)">{{eventsList.eventName}} </td>
                                <td (click)="editEvent(eventsList)">{{eventsList.eventStartDate | date: 'dd-MMM-yyyy'}}
                                </td>
                                <td (click)="editEvent(eventsList)">{{eventsList.eventEndDate | date: 'dd-MMM-yyyy'}}
                                </td>
                                <td>
                                    <div style="display:flex">
                                        <input disabled type="text" [(ngModel)]="eventsList.inviteLink"
                                            name="inviteLink" id="inviteLink" class="form-control" />

                                        <button type="button" [disabled]="eventsList.inviteLink == null"
                                            title="Copy Link" class="btn btn-warning btn-raised"
                                            (click)="copyInviteLinkHandler(eventsList)" style="margin-left:20px">
                                            <i class="fa fa-clone" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </td>
                                <td style="vertical-align: middle; border:1px solid darkgrey">
                                    <div style="text-align: center;">
                                        <p-inputSwitch [(ngModel)]="eventsList.status"
                                            (onChange)="setEventStatus(eventsList)">
                                        </p-inputSwitch>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <tr
                                *ngFor="let eventsList of eventsList | paginate: { itemsPerPage: 10, currentPage: page,totalItems: totalEventsCount };">
                            </tr>
                            <td colspan="6" class="text-center">
                                <pagination-controls style="margin-top: 10px;" (pageChange)="onTableDataChange($event)"
                                    *ngIf="eventsList!=null && eventsList.length>0"></pagination-controls>
                            </td>
                        </ng-template>
                    </p-table>
                </ng-template>

                <!-- <ng-template #screeningEventTemplate>
                    <div class="event-header">Event Details</div>
                    <table class="table table-striped" style="border:1px solid darkgrey">
                        <thead>
                            <tr style="height: 65px;">
                                <th class="col-lg-6"
                                    style="text-align: center; border:1px solid darkgrey;vertical-align: middle;">
                                    Event Details</th>
                                <th class="col-lg-4"
                                    style="text-align: center; border:1px solid darkgrey;vertical-align: middle;">
                                    QR Code</th>
                                <th class="col-lg-2"
                                    style="text-align: center; border:1px solid darkgrey;vertical-align: middle;">
                                    Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-striped">
                                <td style="vertical-align: middle; border:1px solid darkgrey">
                                    <div class="col-lg-12">
                                        <div class="col-xs-12 col-sm-4 col-md-6 col-lg-12" style="margin-bottom:20px">
                                            <label>Screening Event Name</label>
                                            <div class="controls">
                                                <input type="text" placeholder="Enter event name"
                                                    [(ngModel)]="selectedEvent.eventName"
                                                    [disabled]="!selectedEvent.status" style="width:100%" />
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-4 col-md-6 col-lg-5">
                                            <label>Select Start Date </label>
                                            <div>
                                                <input [disabled]="!selectedEvent.status" type="date"
                                                    [(ngModel)]="selectedEvent.eventStartDate" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-4 col-md-6 col-lg-5" style="margin-left:20px">
                                            <label>Select End Date </label>
                                            <div>
                                                <input type="date" [disabled]="!selectedEvent.status"
                                                    [(ngModel)]="selectedEvent.eventEndDate" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-4 col-md-6 col-lg-12" style="margin-top:20px">
                                            <label>Select Screening Center</label>
                                            <div class="controls">
                                                <ng-multiselect-dropdown [disabled]="!selectedEvent.status"
                                                    [settings]="dropdownSettings" [data]="screeningCenterList"
                                                    name="screeningCenterList" [(ngModel)]="selectedEvent.orgId">
                                                </ng-multiselect-dropdown>
                                            </div>
                                        </div>
                                        <div class="row" style="padding: 0 15px;">
                                            <div class="col-xs-12 col-sm-4 col-md-6 col-lg-6" style="margin-top:20px">
                                                <label>Allowed Email Domain(s)</label>
                                                <div class="controls">
                                                    <input type="text" placeholder="Enter allowed email domain(s)"
                                                        [(ngModel)]="selectedEvent.emailDomain"
                                                        [disabled]="!selectedEvent.status" style="width:100%" />
                                                </div>
                                                <span class="desc">(ex: @gmail.com,@yahoo.co.in)</span>
                                            </div>

                                            <div class="col-xs-12 col-sm-4 col-md-6 col-lg-6" style="margin-top:20px">
                                                <label>Restricted Email Domain(s)</label>
                                                <div class="controls">
                                                    <input type="text" placeholder="Enter restricted email domain(s)"
                                                        [(ngModel)]="selectedEvent.restrictedDomains"
                                                        [disabled]="!selectedEvent.status" style="width:100%" />
                                                </div>
                                                <span class="desc">(ex: @gmail.com,@yahoo.co.in)</span>
                                            </div>
                                        </div>
                                        <div class="row" style="padding: 0 15px;">

                                            <div class="col-xs-12 col-sm-4 col-md-6 col-lg-6" style="margin-top:20px">
                                                <label>Minutes Before to Reschedule</label>
                                                <ng-select [items]="minutes" name="rescheduleMinutes"
                                                    bindLabel="itemName"
                                                    [(ngModel)]="selectedEvent.minutesBeforeToReschedule"
                                                    [disabled]="!selectedEvent.status" [clearable]="false"
                                                    [searchable]="true" bindValue="id" placeholder="Minutes">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-4 col-md-6 col-lg-12" style="margin-top:20px">
                                            <label>Notification Reminder</label>
                                            <div style="display:flex">
                                                <div style="width:72px">
                                                    <label>Days</label>
                                                    <ng-select [items]="days" name="notificationDays"
                                                        bindLabel="itemName" [(ngModel)]="selectedEvent.selectedDay"
                                                        [disabled]="!selectedEvent.status" [clearable]="false"
                                                        [searchable]="true" bindValue="id" placeholder="Days">
                                                    </ng-select>
                                                </div>
                                                <div style="margin-left:5%;width:78px">
                                                    <label>Hours</label>
                                                    <ng-select [items]="hours" name="notificationHours"
                                                        bindLabel="itemName" [(ngModel)]="selectedEvent.selectedHour"
                                                        [disabled]="!selectedEvent.status" [clearable]="false"
                                                        [searchable]="true" bindValue="id" placeholder="Hours">
                                                    </ng-select>
                                                </div>
                                                <div style="margin-left:5%;width:92px">
                                                    <label>Minutes</label>
                                                    <ng-select [items]="minutes" name="notificationMinutes"
                                                        bindLabel="itemName" [(ngModel)]="selectedEvent.selectedMinute"
                                                        [disabled]="!selectedEvent.status" [clearable]="false"
                                                        [searchable]="true" bindValue="id" placeholder="Minutes">
                                                    </ng-select>
                                                </div>
                                                <div style="margin-left: 10%;">
                                                    <button class="btn"
                                                        style="position: absolute;bottom: 0; background-color: rgb(0,174,65); color:white"
                                                        (click)="addReminders(selectedEvent)"
                                                        [disabled]="((selectedEvent.selectedDay ==null || selectedEvent.selectedDay==0) && (selectedEvent.selectedHour == null || selectedEvent.selectedHour==0) && (selectedEvent.selectedMinute==null || selectedEvent.selectedMinute==0) || !selectedEvent.status)">
                                                        Add
                                                        Reminder</button>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="col-xs-12 col-sm-4 col-md-6 col-lg-12" style="margin-top:20px">
                                            <button class="button-container"
                                                style="border: 1px solid #FDBD04; margin-top:10px; background-color: rgb(249,190,0);; color: white;cursor: default;"
                                                *ngFor="let item of selectedEvent.reminderAlerts; let i = index"
                                                [ngStyle]="{'margin-left': i%2 == 0 ?'0px':'10px'}">
                                                {{ item.itemName }}
                                                <span class="delete-icon"
                                                    (click)="deleteItem(selectedEvent,item)">×</span>
                                            </button>
                                        </div>
                                        <div class="row" style="padding: 0 15px;">
                                            <div class="col-xs-12 col-sm-4 col-md-6 col-lg-6" style="margin-top:20px">
                                                <div style="text-align: initial; display: grid;">
                                                    <label>Enable Eye Screening Fees?</label>

                                                    <p-inputSwitch [disabled]="!selectedEvent.status"
                                                        [(ngModel)]="selectedEvent.enablePayment">
                                                    </p-inputSwitch>
                                                </div>
                                            </div>

                                            <div *ngIf="selectedEvent.enablePayment"
                                                class="col-xs-12 col-sm-4 col-md-6 col-lg-6" style="margin-top:20px">
                                                <label>Amount in Rs. (incl of taxes)</label>
                                                <div class="controls">
                                                    <input type="number" placeholder="Enter the amount"
                                                        [(ngModel)]="selectedEvent.amount"
                                                        [disabled]="!selectedEvent.status" style="width:100%" min="0"
                                                        (input)="sanitizeAmount()" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 " style="text-align:center; margin-top:20px">
                                            <button type="button" *ngIf="selectedEvent.status"
                                                (click)="createOrUpdateInviteLinkByAccountIdAndOrgId(selectedEvent)"
                                                class="btn btn-info btn-raised">Create/Update Event
                                            </button>
                                        </div>
                                    </div>
                                </td>
                                <td style="vertical-align: middle;border:1px solid darkgrey">
                                    <div class="col-lg-12">

                                        <div *ngIf="selectedEvent.inviteLink"
                                            class="col-xs-12 col-sm-4 col-md-6 col-lg-12">
                                            <label>Invite Link</label>
                                            <div style="display:flex">
                                                <input disabled type="text" [(ngModel)]="selectedEvent.inviteLink"
                                                    name="inviteLink" id="inviteLink" class="form-control" />

                                                <button type="button" [disabled]="selectedEvent.inviteLink == null"
                                                    title="Copy Link" class="btn btn-warning btn-raised"
                                                    (click)="copyInviteLinkHandler(selectedEvent)"
                                                    style="margin-left:20px">
                                                    <i class="fa fa-clone" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div *ngIf="selectedEvent.inviteLink "
                                            class="col-xs-12 col-sm-4 col-md-6 col-lg-12" style="text-align:center">
                                            <iframe [src]="qrCodeUrl+'?data='+selectedEvent.inviteLink | safe"
                                                style="margin-top:10px; height:225px; width:68%; border:0px"></iframe>
                                        </div>
                                        <div class="col-lg-12" style="text-align:center; padding-top:20px">
                                            <button type="button" *ngIf="selectedEvent.status"
                                                class="btn btn-info btn-raised"
                                                (click)="generateInviteLink(selectedEvent)"
                                                style="background-color:#21618C">
                                                Generate Event Link
                                            </button>
                                        </div>
                                    </div>
                                </td>
                                <td style="vertical-align: middle; border:1px solid darkgrey">
                                    <div style="text-align: center;">
                                        <p-inputSwitch [(ngModel)]="selectedEvent.status"
                                            (onChange)="setEventStatus(selectedEvent)">
                                        </p-inputSwitch>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-template> -->

                <ng-template #screeningEventTemplate>
                    <div class="event-header">Event Details</div>
                    <div class="event-setup-container">
                        <!-- Event Details Section -->
                        <div class="event-setup-form-section">
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Event Name
                                            <span class="mandatory-symbol">*</span>
                                        </label>
                                        <input type="text" id="eventName" name="eventName"
                                            [(ngModel)]="selectedEvent.eventName" class="form-control" required
                                            [disabled]="!selectedEvent.status">
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Select Screening Center
                                            <span class="mandatory-symbol">*</span>
                                        </label>
                                        <div class="controls">
                                            <ng-multiselect-dropdown [disabled]="!selectedEvent.status"
                                                [settings]="dropdownSettings" [data]="screeningCenterList"
                                                name="screeningCenterList" [(ngModel)]="selectedEvent.orgId">
                                            </ng-multiselect-dropdown>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Start Date
                                            <span class="mandatory-symbol">*</span>
                                        </label>
                                        <input type="date" id="eventStartDate" name="eventStartDate"
                                            [(ngModel)]="selectedEvent.eventStartDate" class="form-control" required
                                            [disabled]="!selectedEvent.status">
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">End Date
                                            <span class="mandatory-symbol">*</span>
                                        </label>
                                        <input type="date" id="eventEndDate" name="eventEndDate"
                                            [(ngModel)]="selectedEvent.eventEndDate" class="form-control" required
                                            [disabled]="!selectedEvent.status">
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Allowed Email Domains
                                            <span class="event-setup-desc">(ex: @gmail.com,@yahoo.co.in)</span>
                                        </label>
                                        <input type="text" id="emailDomain" name="emailDomain"
                                            [(ngModel)]="selectedEvent.emailDomain" class="form-control" required
                                            [disabled]="!selectedEvent.status">
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Restricted Email Domains
                                            <span class="event-setup-desc">(ex: @gmail.com,@yahoo.co.in)</span>
                                        </label>
                                        <input type="text" id="restrictedDomains" name="restrictedDomains"
                                            [(ngModel)]="selectedEvent.restrictedDomains" class="form-control" required
                                            [disabled]="!selectedEvent.status">
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Reschedule Minutes</label>
                                        <ng-select [items]="minutes" name="rescheduleMinutes" bindLabel="itemName"
                                            [(ngModel)]="selectedEvent.minutesBeforeToReschedule"
                                            [disabled]="!selectedEvent.status" [clearable]="false" [searchable]="true"
                                            bindValue="id" placeholder="Minutes"></ng-select>
                                    </div>
                                </div>
                                <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
                                    <div class="form-group">
                                        <label class="form-label" style="display: block; margin-bottom: 10px;">Enable
                                            Eye Screening
                                            Fees?</label>
                                        <p-inputSwitch [disabled]="!selectedEvent.status"
                                            [(ngModel)]="selectedEvent.enablePayment"></p-inputSwitch>
                                    </div>
                                </div>
                                <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
                                    <div *ngIf="selectedEvent.enablePayment" class="form-group">
                                        <label class="form-label">Amount in Rs. (incl of taxes)
                                            <span class="mandatory-symbol">*</span>
                                        </label>
                                        <input type="number" id="amount" name="amount"
                                            [(ngModel)]="selectedEvent.amount" class="form-control" required
                                            [disabled]="!selectedEvent.status" min="0" (input)="sanitizeAmount()">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Notification Reminder</label>
                                        <div class="event-setup-notification-reminder">
                                            <div class="event-setup-notification-item">
                                                <label>Days</label>
                                                <ng-select [items]="days" name="notificationDays" bindLabel="itemName"
                                                    [(ngModel)]="selectedEvent.selectedDay"
                                                    [disabled]="!selectedEvent.status" [clearable]="false"
                                                    [searchable]="true" bindValue="id" placeholder="Days"></ng-select>
                                            </div>
                                            <div class="event-setup-notification-item">
                                                <label>Hours</label>
                                                <ng-select [items]="hours" name="notificationHours" bindLabel="itemName"
                                                    [(ngModel)]="selectedEvent.selectedHour"
                                                    [disabled]="!selectedEvent.status" [clearable]="false"
                                                    [searchable]="true" bindValue="id" placeholder="Hours"></ng-select>
                                            </div>
                                            <div class="event-setup-notification-item">
                                                <label>Minutes</label>
                                                <ng-select [items]="minutes" name="notificationMinutes"
                                                    bindLabel="itemName" [(ngModel)]="selectedEvent.selectedMinute"
                                                    [disabled]="!selectedEvent.status" [clearable]="false"
                                                    [searchable]="true" bindValue="id"
                                                    placeholder="Minutes"></ng-select>
                                            </div>
                                            <div class="event-setup-notification-add">
                                                <button class="btn btn-success" (click)="addReminders(selectedEvent)"
                                                    [disabled]="((selectedEvent.selectedDay == null || selectedEvent.selectedDay == 0) && (selectedEvent.selectedHour == null || selectedEvent.selectedHour == 0) && (selectedEvent.selectedMinute == null || selectedEvent.selectedMinute == 0) || !selectedEvent.status)">
                                                    Add Reminder
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" style="margin-bottom:20px">
                                    <button class="button-container"
                                        style="border: 1px solid #FDBD04; margin-top:10px; background-color: rgb(249,190,0);; color: white;cursor: default;"
                                        *ngFor="let item of selectedEvent.reminderAlerts; let i = index"
                                        [ngStyle]="{'margin-left': i%2 == 0 ?'0px':'10px'}">
                                        {{ item.itemName }}
                                        <span class="delete-icon" (click)="deleteItem(selectedEvent,item)">×</span>
                                    </button>
                                </div>

                            </div>
                            <div class="row">
                                <div *ngIf="selectedEvent.inviteLink" class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label class="form-label">Invite Link</label>
                                        <div class="event-setup-invite-link">
                                            <input type="text" id="inviteLink" name="inviteLink"
                                                [(ngModel)]="selectedEvent.inviteLink" class="form-control" disabled>
                                            <button type="button" [disabled]="!selectedEvent.inviteLink"
                                                title="Copy Link" class="btn btn-warning btn-raised"
                                                (click)="copyInviteLinkHandler(selectedEvent)">
                                                <i class="fa fa-clone" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label" style="display: block; margin-bottom: 10px;">Event Status</label>
                                        <p-inputSwitch [(ngModel)]="selectedEvent.status"
                                            (onChange)="setEventStatus(selectedEvent)">
                                        </p-inputSwitch>
                                    </div>
                                </div>
                                <div *ngIf="selectedEvent.inviteLink" class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="form-group" style="text-align: center;">
                                        <label class="form-label">QR Code</label>
                                        <iframe [src]="qrCodeUrl+'?data='+selectedEvent.inviteLink | safe"
                                            style="margin-top:10px; height:225px; width:100%; border:0px"></iframe>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" style="text-align:center; margin-top: 20px;">
                                <button type="button" *ngIf="selectedEvent.status"
                                    (click)="createOrUpdateInviteLinkByAccountIdAndOrgId(selectedEvent)"
                                    class="btn btn-info btn-raised">Create/Update Event</button>
                                <button type="button" *ngIf="selectedEvent.status" class="btn btn-info btn-raised"
                                    (click)="generateInviteLink(selectedEvent)" style="background-color:#21618C; margin-left: 20px;"
                                    [disabled]="!enableGenerateLinkButton">
                                    Generate Event Link
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>